import type { JSX } from 'react';
import classNames from 'classnames';
import { Control, FieldValues, Path, PathValue } from 'react-hook-form';

import { FormDatePicker, FormSelect, FormSwitch, FormTextInput } from '@/shared/ui';

import { DateFormField, FormFieldProps, SelectFormField, SwitchFormField, TextFormField } from './types';

export const getComponent = <T extends FieldValues = FieldValues>(
  props: Omit<FormFieldProps<T>, 'show'>,
  control: Control<T>,
  fieldClassName?: string,
): JSX.Element => {
  const { defaultValue, ...restProps } = props;

  const baseProps = {
    control,
    name: props.name as Path<T>,
    className: classNames('form-builder__field', fieldClassName),
    defaultValue: defaultValue as PathValue<T, Path<T>>,
  };

  switch (restProps.component) {
    case 'text':
      return <FormTextInput {...baseProps} {...(restProps as Omit<TextFormField<T>, 'defaultValue'>)} />;
    case 'switch':
      return <FormSwitch {...baseProps} {...(restProps as Omit<SwitchFormField<T>, 'defaultValue'>)} />;
    case 'select':
      return <FormSelect {...baseProps} {...(restProps as Omit<SelectFormField<T>, 'defaultValue'>)} />;
    case 'date':
      return <FormDatePicker {...baseProps} {...(restProps as Omit<DateFormField<T>, 'defaultValue'>)} />;
    default:
      return <FormTextInput {...baseProps} {...(restProps as Omit<TextFormField<T>, 'defaultValue'>)} />;
  }
};
